import React from "react";
import "./skykey.css";
import "./admin.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SettingsProvider } from "./context/SettingsContext";
import { getToken } from "./lib/api";
import Home from "./pages/Home";
import FleetPage from "./pages/FleetPage";
import AircraftDetailPage from "./pages/AircraftDetailPage";
import { HowItWorksPage, AboutPage, ContactPage, PrivacyPage, TermsPage } from "./pages/StaticPages";
import LoginPage from "./pages/LoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminLeadDetail from "./pages/admin/AdminLeadDetail";
import AdminOperators from "./pages/admin/AdminOperators";
import AdminAircraft from "./pages/admin/AdminAircraft";
import AdminSettings from "./pages/admin/AdminSettings";

function RequireAuth({ children }) {
  return getToken() ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fleet" element={<FleetPage />} />
          <Route path="/aircraft/:slug" element={<AircraftDetailPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
            <Route index element={<AdminDashboard />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="leads/:id" element={<AdminLeadDetail />} />
            <Route path="operators" element={<AdminOperators />} />
            <Route path="aircraft" element={<AdminAircraft />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
